module.exports = "/static-assets/_next/static/images/gifts-f7302fb58864a4356f0f4923f63a9d98.png";